export default "__VITE_ASSET__a40cd082__"